import { Grid } from '@mui/material';
import React from 'react';

import { TotalsBox } from 'ui/analytics/TotalsBox';
import { AudienceMeasureConfig, AudienceMeasureTotal, EAudienceMeasureType } from './model';

interface AudienceTotalBoxesProps {
    values: AudienceMeasureTotal[];
    onMeasureClick?: (measure: EAudienceMeasureType) => void;
    selectedMeasure?: EAudienceMeasureType;
    datePoints: [Date, Date, Date];
    config: Record<EAudienceMeasureType, AudienceMeasureConfig>;
}

export const AudienceMeasureTotalBoxes: React.FC<AudienceTotalBoxesProps> = ({
    values,
    onMeasureClick,
    selectedMeasure,
    datePoints,
    config
}) => {
    const renderMeasure = React.useCallback(
        (option: AudienceMeasureTotal) => {
            const { title, subtitle, format, description } = config[option.key];
            return (
                <Grid
                    key={option.key}
                    size={{
                        xs: 6,
                        sm: 3
                    }}
                >
                    <TotalsBox
                        datePoints={datePoints}
                        measure={option}
                        active={option.key === selectedMeasure}
                        onClick={onMeasureClick}
                        title={title}
                        subtitle={subtitle}
                        format={format}
                        description={description}
                    />
                </Grid>
            );
        },
        [datePoints, onMeasureClick, selectedMeasure, config]
    );
    return (
        <Grid container spacing={3}>
            {values.map(renderMeasure)}
        </Grid>
    );
};
